import Proj4js from "proj4";

const projection3degree = (lon_0) =>
  `+proj=tmerc +lat_0=0 +lon_0=${lon_0} +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs`;
// VN2000 Hoi nhap mui 3
const htd_103_hn = projection3degree(103);
const htd_104_hn = projection3degree(104);
const htd_104_3_hn = projection3degree(104.5);
const htd_104_45_hn = projection3degree(105.75);
const htd_105_hn = projection3degree(105);
const htd_105_45hn = projection3degree(105.75);
const htd_105_30_hn = projection3degree(105.5);
const htd_106_hn = projection3degree(106);
const htd_106_15_hn = projection3degree(106.25);
const htd_106_30_hn = projection3degree(106.5);
const htd_107_hn = projection3degree(107);
const htd_107_15_hn = projection3degree(107.25);
const htd_107_30_hn = projection3degree(107.5);
const htd_107_45_hn = projection3degree(107.75);
const htd_108_hn = projection3degree(108);
const htd_108_15_hn = projection3degree(108.25);
const htd_108_30_hn = projection3degree(108.5);

const provinces = [
  { name: "Lai Châu", id: 1, value: htd_103_hn },
  { name: "Điện Biên", id: 2, value: htd_103_hn },
  { name: "Sơn la", id: 3, value: htd_104_hn },
  { name: "Kiên Giang", id: 4, value: htd_104_3_hn },
  { name: "Cà Mau", id: 5, value: htd_104_3_hn },
  { name: "Lào Cai", id: 6, value: htd_104_45_hn },
  { name: "Yên Bái", id: 7, value: htd_104_45_hn },
  { name: "Nghệ An", id: 8, value: htd_104_45_hn },
  { name: "Phú Thọ", id: 9, value: htd_104_45_hn },
  { name: "An Giang", id: 10, value: htd_104_45_hn },
  { name: "Thanh Hóa", id: 11, value: htd_105_hn },
  { name: "Vĩnh Phúc", id: 12, value: htd_105_hn },
  { name: "Bình Thuận", id: 13, value: htd_108_30_hn },
  { name: "Đồng Tháp", id: 14, value: htd_105_hn },
  { name: "Cần Thơ", id: 15, value: htd_105_hn },
  { name: "Hậu Giang", id: 16, value: htd_105_hn },
  { name: "Long An", id: 17, value: htd_104_45_hn },
  { name: "Tiền Giang", id: 18, value: htd_104_45_hn },
  { name: "Bến Tre", id: 19, value: htd_104_45_hn },
  { name: "Hải Phòng", id: 20, value: htd_104_45_hn },
  { name: "Hồ Chí Minh", id: 21, value: htd_104_45_hn },
  { name: "Bình Dương", id: 22, value: htd_104_45_hn },
  { name: "Tuyên Quang", id: 23, value: htd_106_hn },
  { name: "Hòa Bình", id: 24, value: htd_106_hn },
  { name: "Quảng Bình", id: 25, value: htd_106_hn },
  { name: "Quảng Trị", id: 26, value: htd_106_15_hn },
  { name: "Bình Phước", id: 27, value: htd_106_15_hn },
  { name: "Bắc Cạn", id: 28, value: htd_106_30_hn },
  { name: "Thái Nguyên", id: 29, value: htd_106_30_hn },
  { name: "Bắc Giang", id: 30, value: htd_107_hn },
  { name: "Thừa Thiên - Huế", id: 31, value: htd_107_hn },
  { name: "Lạng Sơn", id: 32, value: htd_107_15_hn },
  { name: "Bạc Liêu", id: 33, value: htd_105_hn },
  { name: "Hà Nội", id: 34, value: htd_105_hn },
  { name: "Ninh Bình", id: 35, value: htd_105_hn },
  { name: "Hà Nam", id: 36, value: htd_105_hn },
  { name: "Hà Giang", id: 37, value: htd_105_30_hn },
  { name: "Hải Dương", id: 38, value: htd_105_30_hn },
  { name: "Hà Tĩnh", id: 39, value: htd_105_30_hn },
  { name: "Bắc Ninh", id: 40, value: htd_105_30_hn },
  { name: "Hưng Yên", id: 41, value: htd_105_30_hn },
  { name: "Thái Bình", id: 42, value: htd_105_30_hn },
  { name: "Nam Định", id: 43, value: htd_105_30_hn },
  { name: "Tây Ninh", id: 44, value: htd_105_30_hn },
  { name: "Vĩnh Long", id: 45, value: htd_105_30_hn },
  { name: "Sóc Trăng", id: 46, value: htd_105_30_hn },
  { name: "Trà Vinh", id: 47, value: htd_107_30_hn },
  { name: "Kon Tum", id: 48, value: htd_107_30_hn },
  { name: "Quảng Ninh", id: 49, value: htd_107_45_hn },
  { name: "Đồng Nai", id: 50, value: htd_107_45_hn },
  { name: "Bà Rịa - Vũng Tàu", id: 51, value: htd_107_45_hn },
  { name: "Quảng Nam", id: 52, value: htd_107_45_hn },
  { name: "Lâm Đồng", id: 53, value: htd_107_45_hn },
  { name: "Đà Nẵng", id: 54, value: htd_107_45_hn },
  { name: "Quảng Ngãi", id: 55, value: htd_108_hn },
  { name: "Ninh Thuận", id: 56, value: htd_108_15_hn },
  { name: "Khánh Hòa", id: 57, value: htd_108_15_hn },
  { name: "Bình Định", id: 58, value: htd_108_15_hn },
  { name: "Đắc Lắc", id: 59, value: htd_108_30_hn },
  { name: "Đắc Nông", id: 60, value: htd_108_30_hn },
  { name: "Phú Yên", id: 61, value: htd_108_30_hn },
  { name: "Gia Lai", id: 62, value: htd_108_30_hn },
  { name: "Cao Bằng", id: 63, value: htd_105_45hn },
];

const formatLongLat = (number) => {
  return !!number ? number.toFixed(10) : "";
};
const vnProvices = provinces.sort(function (a, b) {
  return a.name - b.name;
});
const Vn2000 = {
  vn2000ToWGG84: (x, y, fromProjection) => {
    let defintion_WGG84 = Proj4js.defs("EPSG:4326");
    //let defintion_Google=Proj4js.defs('EPSG:3857');
    let caculatedPoint = Proj4js(fromProjection, defintion_WGG84, [y, x]);
    return {
      longitude: formatLongLat(caculatedPoint[0]),
      latitude: formatLongLat(caculatedPoint[1]),
    };
  },
  convertVn2000ToWGG84: (x, y, proviceId) => {
    const fromProjection = Vn2000.provinces.find((p) => p.id === proviceId);
    if (!fromProjection) {
      console.warn("province id is not found !");
      return;
    }
    let defintion_WGG84 = Proj4js.defs("EPSG:4326");
    let caculatedPoint = Proj4js(fromProjection.value, defintion_WGG84, [y, x]);
    return {
      longitude: formatLongLat(caculatedPoint[0]),
      latitude: formatLongLat(caculatedPoint[1]),
    };
  },
  convertWGG84ToVn2000: (latitude, longitude, proviceId) => {
    const toProjection = Vn2000.provinces.find((p) => p.id === proviceId);
    if (!toProjection) {
      console.warn("province id is not found !");
      return;
    }
    let defintion_WGG84 = Proj4js.defs("EPSG:4326");
    let caculatedPoint = Proj4js(toProjection.value,defintion_WGG84).inverse([
      longitude,
      latitude
    ]);
    return {
      x: formatLongLat(caculatedPoint[1]),
      y: formatLongLat(caculatedPoint[0]),
    };
  },
  provinces: vnProvices,
  formatLongLat,
};
export default Vn2000;
